import React, { Fragment, useRef, useState, memo } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { makeStyles } from '@mui/styles';
import {
	ListItemIcon,
	ListItemText,
	Tooltip,
	IconButton,
	Menu,
	MenuItem,
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import MoreIcon from '@mui/icons-material/MoreVert';

import { ToggleAddProjectDialog } from '../../../../../../../../actions/OperatorsActions.js';

const useStyles = makeStyles(() => ({}));

const ActionsButton = (props) => {
	const classes = useStyles();
	const moreRef = useRef(null);
	const [openMenu, setOpenMenu] = useState(false);
	const dispatch = useDispatch();
	const handleMenuOpen = () => {
		setOpenMenu(true);
	};

	const handleMenuClose = () => {
		setOpenMenu(false);
	};

	const _add = () => {
		dispatch(ToggleAddProjectDialog(true));
		setOpenMenu(false);
	};

	return (
		<>
			<Tooltip title="More options">
				<IconButton
					{...props}
					onClick={handleMenuOpen}
					ref={moreRef}
					size="small"
				>
					<MoreIcon />
				</IconButton>
			</Tooltip>
			<Menu
				anchorEl={moreRef.current}
				anchorOrigin={{
					vertical: 'top',
					horizontal: 'left',
				}}
				classes={{ paper: classes.menu }}
				onClose={handleMenuClose}
				open={openMenu}
				transformOrigin={{
					vertical: 'top',
					horizontal: 'left',
				}}
			>
				<MenuItem onClick={_add}>
					<ListItemIcon>
						<AddIcon />
					</ListItemIcon>
					<ListItemText primary="Add" />
				</MenuItem>
			</Menu>
		</>
	);
};

ActionsButton.propTypes = {
	className: PropTypes.string,
};

export default memo(ActionsButton);
